import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import { PLOT_DATA_LOADED, PLOT_DATA_LOADING, PLOT_DATA_ERROR } from 'redux/actionTypes/componentConfig';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import fetchWork from 'utils/work/fetchWork';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var getClusterNames = function getClusterNames(cellSets) {
  var clusterIds = cellSets.hierarchy.reduce(function (acc, cellSet) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(cellSet.children.map(function (entry) {
      return entry.key;
    })));
  }, []);
  var clusterNames = clusterIds === null || clusterIds === void 0 ? void 0 : clusterIds.map(function (clusterId) {
    return cellSets.properties[clusterId].name;
  });
  return clusterNames;
};
var transformToPlotData = function transformToPlotData(data) {
  var result = [];
  data.cellSetsIdx.forEach(function (cellSetIdx, arrIdx) {
    result.push({
      avgExpression: data.avgExpression[arrIdx],
      cellSets: data.cellSetsNames[cellSetIdx],
      cellsPercentage: data.cellsPercentage[arrIdx],
      geneName: data.geneNames[data.geneNameIdx[arrIdx]]
    });
  });
  return result;
};
var orderCellSets = function orderCellSets(data, cellSets, config) {
  // reordering data based on the sample order
  var selectedCellSet = config.selectedCellSet;
  var hierarchy = cellSets.hierarchy,
    properties = cellSets.properties;
  if (hierarchy.length) {
    var cellSetOrderKeys = hierarchy.filter(function (rootNode) {
      return rootNode.key === selectedCellSet;
    })[0].children.map(function (cellSet) {
      return cellSet.key;
    });
    var cellSetOrderNames = cellSetOrderKeys.map(function (cellSet) {
      return properties[cellSet].name;
    });
    data.sort(function (a, b) {
      return cellSetOrderNames.indexOf(a.cellSets) - cellSetOrderNames.indexOf(b.cellSets);
    });
  }
};
var getDotPlot = function getDotPlot(experimentId, plotUuid, config) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var cellSets, clusterNames, timeout, _config$selectedPoint, _config$selectedPoint2, filterGroup, filterKey, body, data, plotData, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cellSets = getCellSets()(getState().cellSets);
            clusterNames = getClusterNames(cellSets);
            timeout = getTimeoutForWorkerTask(getState(), 'PlotData');
            _config$selectedPoint = config.selectedPoints.split('/'), _config$selectedPoint2 = _slicedToArray(_config$selectedPoint, 2), filterGroup = _config$selectedPoint2[0], filterKey = _config$selectedPoint2[1];
            body = {
              name: 'DotPlot',
              useMarkerGenes: config.useMarkerGenes,
              numberOfMarkers: config.nMarkerGenes,
              customGenesList: config.selectedGenes,
              groupBy: config.selectedCellSet,
              filterBy: {
                group: filterGroup,
                key: filterKey || 'All'
              },
              // clusterNames is used for triggering a work request upon cluster name change
              clusterNames: clusterNames
            };
            _context.prev = 5;
            dispatch({
              type: PLOT_DATA_LOADING,
              payload: {
                plotUuid: plotUuid
              }
            });
            _context.next = 9;
            return fetchWork(experimentId, body, getState, dispatch, {
              timeout: timeout
            });
          case 9:
            data = _context.sent;
            plotData = transformToPlotData(data);
            orderCellSets(plotData, cellSets, config);
            dispatch({
              type: PLOT_DATA_LOADED,
              payload: {
                plotUuid: plotUuid,
                plotData: plotData
              }
            });
            _context.next = 19;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_PLOT_DATA);
            dispatch({
              type: PLOT_DATA_ERROR,
              payload: {
                plotUuid: plotUuid,
                error: errorMessage
              }
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default getDotPlot;